import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useQuery } from "@tanstack/react-query";
import { getStoreProducts } from "../../../../apis/requests";
import useLang from "../../../../hooks/useLang";
import { useTranslation } from "react-i18next";
import { formatCurrency, formatPrice } from "../../../../utils/utils";
import { Link } from "react-router-dom";
import BentoLoader from './loaders/BentoLoader';
const RecomandedProducts = () => {
    const lang = useLang();
    const { t } = useTranslation();
    const queryParams = {
        page: 1,
        per_page: 3,
        type: "browse",
        id: "recommended_product",
    };

    const { data, isLoading } = useQuery({
        queryKey: ["recommended-products"],
        queryFn: () => getStoreProducts(queryParams),
    });
    const products = data?.data?.data || [];
    return (
        <section className="relative bg-[#004040] py-12 overflow-hidden mt-10 text-slate-300">
            {
                isLoading &&
                <BentoLoader />

            }
            {
                !isLoading &&
                <div className="lg:px-12 px-4">

                    <div className="mb-16 flex justify-between items-end">
                        <div>
                            <h2 className="mt-4 lg:text-4xl text-xl font-semibold tracking-tight">
                               {t('recommended_products')}
                            </h2>
                        </div>
                        <Link className="text-sm border rounded-full px-5 py-2 font-bold"
                            to={'/shop/top-recommended'}
                        >
                           {t('see_all')}
                        </Link>
                    </div>
                    <div className="grid lg:grid-cols-3 gap-8">
                        <div className="lg:col-span-2 lg:block hidden">
                            <FeaturedCard product={products[0]} />
                        </div>

                        <div className="hidden lg:block space-y-6 grid  gap-3">
                            {products.slice(1, 3).map(product => (
                                <MiniCard
                                    key={product.sku}
                                    product={product}
                                />
                            ))}
                        </div>
                        <div className="lg:hidden space-y-2 grid gap-1">
                            {products.slice(0, 3).map(product => (
                                <MiniCard
                                    key={product.sku}
                                    product={product}
                                />
                            ))}
                        </div>

                    </div>

                </div>
            }

        </section>
    );
};
const FeaturedCard = ({ product }) => {
    const lang = useLang();
    const { t } = useTranslation();
    return (
        <div
            className="relative overflow-hidden rounded-[36px] bg-[#F7F7F8] col-span-6">
            <div
                className="grid grid-cols-1 md:grid-cols-2">
                <div
                    className="flex lg:flex-col justify-around lg:p-10 p-6">
                    <p className="hidden lg:block text-sm uppercase tracking-[0.35em] text-gray-400">
                        {t('top_recommended')}
                    </p>
                    <div className="lg:hidden">
                        <img
                            src={product.image}
                            alt={product.name}
                            className="w-100 rounded-2xl"
                        />
                    </div>
                    <div className="lg:p-2 p-6">
                        <h3 className=" mt-6 text-4xl lg:text-5xl font-semibold leading-tight text-gray-900 ">
                            {lang === "en" ? product?.name : product?.name_ar}
                        </h3>
                        <h4 className="my-6 font-bold text-slate-800">{formatPrice(product.selling_price)}</h4>
                    </div>
                    <Link
                        to={'/shop/products/' + product.sku}
                        className="w-fit font-bold rounded-full bg-black px-8 py-3 text-white transition duration-300 hover:bg-gray-800"
                    >
                        {t('add_to_cart')}
                    </Link>
                </div>
                <div className={`relative flex items-center justify-center overflow-hidden ${lang === "en" ? "lg:-mr-20" : "lg:-ml-20"}`} >
                    <img
                        src={product?.image}
                        alt={product?.name}
                        className="w-100 object-contain hidden lg:block"
                    />
                </div>
            </div>
        </div>
    );
}

const MiniCard = ({ product }) => {
    const { t } = useTranslation();
    return (
        <div className="rounded-2xl border border-gray-200 p-6 text-slate-700 bg-white">
            <div className="flex justify-between">
                <div className="w-full flex-col flex justify-around" >
                    <h4 className="text-xl font-bold">
                        {product.name}
                    </h4>
                    <div className="flex flex-col justify-center gap-4">
                        <h2 className="font-bold">{formatPrice(product?.selling_price)}</h2>
                        <Link
                            to={'/shop/products/' + product.sku}
                            className="w-fit font-bold rounded-full bg-black px-8 py-3 -mx-3 text-white"
                        >
                            {t('add_to_cart')}
                        </Link>
                    </div>
                </div>
                <div>
                    <img className="w-60 rounded-xl" src={product.image} alt="" />
                </div>
            </div>
        </div>
    );
}
export default RecomandedProducts;